<template>
  <component
    :is="currentComponent"
    v-if="dealData"
    v-model="isShownStatusInfo"
    :deal="dealData"
    @refund="handleRefund"
  />
</template>

<script>
import { EVENT_BUS } from '@/eventBus';

const COMPONENTS_MAP = {
  ['OPENED']: () => import('organisms/safe-deal/components/SafeDealOpenedStatusDialog'),
  ['CLOSED']: () => import('organisms/safe-deal/components/SafeDealClosedStatusDialog'),
  ['CHALLENGE_PROCESSING']: () => import('organisms/safe-deal/components/SafeDealChallengeProcessingStatusDialog'),
  ['CHALLENGE_SUCCESS']: () => import('organisms/safe-deal/components/SafeDealChallengeSuccessStatusDialog'),
  ['REFUND_PROCESSING']: () => import('organisms/safe-deal/components/SafeDealRefundProcessingStatusDialog'),
};

export default {
  name: 'SafeDealStatusInfoController',
  props: {
    transaction: {
      type: Object,
      required: true,
    },
  },
  created() {
    // TODO: @danealton возможно стоит избавить от этого, поскольку есть пропс transaction
    EVENT_BUS.$on('EVENT_SHOW_SAFE_DEAL_STATUS', deal => {
      this.dealData = deal;
      this.currentComponent = COMPONENTS_MAP[deal.status];
      this.isShownStatusInfo = true;
    });

    EVENT_BUS.$on('DEAL_UPDATE', () => {
      this.isShownStatusInfo = false;
    });
  },
  data() {
    return {
      dealData: null,
      currentComponent: null,
      isShownStatusInfo: false,
    };
  },
  methods: {
    async handleRefund() {
      this.isShownStatusInfo = false;

      await this.$nextTick;
      EVENT_BUS.$emit('REFUND_CONFIRM', this.transaction.public_id);
    },
  },
};
</script>
